import api from '@/api'
import { WITH_LOADING } from '@/store/action-types'
const rootTrue = Object.freeze({ root: true })

const actions = {
  fetchTransCode: ({ commit, dispatch }) => {
    const action = api.get('/ins/common/insPolicies/serno').then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  delCusInfo: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.delete('/ins/common/insPolicies/cus', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchCusInfoCopy: ({ commit, dispatch }, payload) => {
    const params = payload // 查詢頁-要保書複製
    const action = api.get('/ins/common/insPolicies/cusInfoCopy', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  fetchInsPolicies: ({ commit, dispatch }, payload) => {
    const params = payload // 抓取保單資料服務
    const action = api.get('/ins/common/insPolicies', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postInterViewResult: ({ commit, dispatch }, payload) => {
    const params = payload // 儲存回填電訪結果
    const action = api.post('/ins/common/insPolicies/interViewResult', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  postWritSendDate: ({ commit, dispatch }, payload) => {
    const params = payload // 回填寄件日期
    const action = api.post('/ins/common/insPolicies/writSendDate', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  postReSendWritten: ({ commit, dispatch }, payload) => {
    const params = payload // 重寄書面分析
    const action = api.post('/ins/common/insPolicies/reSendWritten', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  fetchInsPoliciesPolf: ({ commit, dispatch }, payload) => {
    const params = payload // 保單上傳檔案資料服務(INS_POLF-S01)
    const action = api.get('/ins/common/insPolicies/polf', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  fetchInsPoliciesRecords: ({ commit, dispatch }, payload) => {
    const params = payload //  保單附件填寫紀錄資料服務(INS_POLREC-S01)
    const action = api.get('/ins/common/insPolicies/records', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  fetchCheckItem: ({ commit, dispatch }, payload) => {
    const params = payload // 檢核項目來源資料 initCheckItem
    const action = api.get('/ins/upload/initCheckItem', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postCheckItem: ({ commit, dispatch }, payload) => {
    const params = payload // 檢核項目 儲存
    const action = api.post('/ins/upload/saveCheckItem', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postUpdFileBase64: ({ commit, dispatch }, payload) => {
    let base64Str = payload.base64Str
    if (base64Str && base64Str.length > 0) { // 檢核項目、附件上傳 上傳檔案
      const action = api.post('/ins/upload/updFileBase64', payload).then(r => {
        return r
      })
      return dispatch(WITH_LOADING, { action }, rootTrue)
    }
  },
  delFile: ({ commit, dispatch }, payload) => {
    const params = payload // 檢核項目、附件上傳 刪除檔案
    const action = api.delete('/ins/upload/file', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  delAllFile: ({ commit, dispatch }, payload) => {
    const params = payload // 依據transCode刪除所有已在DB的上傳檔案
    const action = api.delete('/ins/upload/allFile', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAttachmentUpload: ({ commit, dispatch }, payload) => {
    let base64Str = payload.base64Str // 附件上傳 儲存
    const action = api.post('/ins/upload/saveAttachmentUpload', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  checkIdnCard : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/checkIdnCard', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchIdnCusData : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/fetchIdnCusData', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },

  saveInsCusWorkOutData: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.post('/ins/common/insPolicies/saveCusWorkOutData', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  checkAgentService : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/checkAgentService', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchLegalAgent : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/legalAgentInfo', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postLegalAgent : ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/cus/legalAgent', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  checkCusName : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/checkCusName', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchCusInfo : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/cusInfo', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postCusInfo : ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/cus/cusInfo', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchJumpApp: ({ commit, dispatch }, payload) => {
    const params = payload // 跳轉APP 所需URL
    const action = api.get('/ins/common/insPolicies/jumpAppData', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchWrittenData: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/written/writtenData', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postWrittenData: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/written/writtenData', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchInsPoliciesInfo: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/insPoliciesInfo', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  updatePolState : ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/common/updatePolState', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  queryReleasePermit: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/releasePermitList', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchReleasePermitInfo: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/releasePermitInfo', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  auditReleasePermit: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/common/auditReleasePermit', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAgentFilesReq: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/agentFilesReq', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchInsPoliciesAnnexRisk: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/insPoliciesAnnexRisk', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  saveInsPoliciesAnnexRisk: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/common/insPoliciesAnnexRisk', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  saveInsPoliciesAnnexEdd: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/common/insPoliciesAnnexEdd', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  savePolaa: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/common/savePolaa', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchLifcApi: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/lifcApi', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  agentFilesFinish: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/agentFilesFinish', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  delEdd: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/delEdd', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  putDlvData: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/putDlvData', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchUserFinance: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/userFinance', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchPolicyStatusNum: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/common/policyStatusNum', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchSendsms: ({ commit, dispatch }, payload) => {
    const action = api.post('/ins/cus/sendsms', payload).then(r => {
      return r
    })//個資同意 發送簡訊
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchCusAgree: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/ins/cus/cusAgree', { params }).then(r => {
      return r
    })// 取得個資同意資料
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  saveCusAgree: ({ commit, dispatch }, payload) => {
    const action = api.post('public/ins/cus/cusAgree', payload).then(r => {
      return r
    }) // 儲存個資同意資料
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  checkCusNameAndIdnCard : ({ commit, dispatch }, payload) => {
    //add SCR #82813 , 加入保經表單一進入後，立即進行 被保險人和法定代理人進行姓名發查檢核
    const params = payload
    const action = api.get('/ins/cus/checkCusNameAndIdnCard', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
}
const ins = {
  namespaced: true,
  state () {},
  getters: {},
  mutations: {},
  actions
}
export default ins
